import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import {
  ReviewInterface,
  SimpleStatRatingInterface,
} from '@sport-activities/sdk';

import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { RatingSizeEnum } from '~/component/vtmn-rating/enums/RatingSize.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
@Component({
  selector: 'app-activity-reviews',
  templateUrl: './activity-reviews.component.html',
  styleUrls: ['./activity-reviews.component.scss'],
})
export class ActivityReviewsComponent {
  @Input() public averageAttributeRating: SimpleStatRatingInterface[];
  @Input() public averageRating: number;
  @Input() public hasReview: boolean;
  @Input() public recommendationRate: number;
  @Input() public review: ReviewInterface;
  @Input() public reviewCount: number;
  @Input() public reviews: ReviewInterface[];

  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly ratingSize = RatingSizeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;

  constructor(
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly translateService: TranslateService
  ) {}

  public getActivityReviewsLink(): string {
    return this.localizeRouterService
      .translateRoute('attendee.reviews')
      .toString();
  }

  public get reviewsTranslation(): string {
    return this.reviewCount > 1
      ? this.translateService.instant('reviews.number_of_reviews', {
          numberOfReviews: this.reviewCount || 0,
        })
      : this.translateService.instant('reviews.number_of_review', {
          numberOfReviews: this.reviewCount || 0,
        });
  }
}
